import classNames from 'classnames';
import React, { FC } from 'react';

interface GeneralInfoBodyPartProps {
  header?: string;
  className?: string
}

export const GeneralInfoBodyPart: FC<GeneralInfoBodyPartProps> = (props) => {
  const { header, className, children } = props;
  return (
    <div className={classNames("generalInfoBodyPart", className)}>
      {header && (
        <span className="generalInfoBodyPart__header">{header}</span>
      )}
      <div className="generalInfoBodyPart__children">
        {children}
      </div>
    </div>
  )
};
